import { ERROR_FORM_ANSWERS_NEEDED, missionPEField } from '../../../../../utils/constants'

export default (page_element, answer) => {
  const has_answer = !page_element.required ||
    answer[missionPEField(page_element)]
  return {
    valid: !!has_answer,
    is_correct_answer: !!has_answer,
    errors: has_answer ? new Set() : new Set([
      ERROR_FORM_ANSWERS_NEEDED,
    ]),
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/Form/input.jsx